import { useMemo } from 'react'
import extractTourV2SnapshotDetails from 'lib/tours/extractTourV2SnapshotDetails'

function useTourV2SnapshotDetails(
  snapshot: App.Tours.TourV2OfferSnapshot | undefined,
): ReturnType<typeof extractTourV2SnapshotDetails> {
  return useMemo(() => extractTourV2SnapshotDetails(snapshot), [snapshot])
}

export default useTourV2SnapshotDetails
